import DrawingSelectionNoticeModal from 'components/modals/DrawingSelectionNoticeModal';
import { isTablet } from 'constants/browserDetection';
import { buttons } from 'copy/copy';
import React, { useState } from 'react';

export type ManageDrawingsSupportValue = {
  onSuccess: (callBack: () => Promise<void>) => void;
};

export const ManageDrawingsSupportContext =
  React.createContext<ManageDrawingsSupportValue>({
    onSuccess: (callBack) => {},
  });

export const ManageDrawingsSupportProvider: React.FC = ({ children }) => {
  const [modal, setModal] = useState<React.ReactNode>();

  const evaluationValue: ManageDrawingsSupportValue = {
    onSuccess: async (callBack) => {
      if (isTablet) {
        setModal(
          <DrawingSelectionNoticeModal
            title="Drawing Selection Notice"
            closeButtonText={buttons.dismiss}
            onModalClose={() => setModal(null)}
          />
        );
      } else {
        await callBack();
      }
    },
  };

  return (
    <ManageDrawingsSupportContext.Provider value={evaluationValue}>
      {children}
      {modal}
    </ManageDrawingsSupportContext.Provider>
  );
};
